import { render } from "./InstagramSvg.vue?vue&type=template&id=1d7cdda1"
import script from "./InstagramSvg.vue?vue&type=script&lang=ts"
export * from "./InstagramSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script